import React from 'react'
import PropTypes from 'prop-types'

import LoadingBox from 'src/ui/LoadingBox/LoadingBox'
import ListSkeleton from 'src/ui/List/ListSkeleton'

const placeholderItems = Array.from({ length: 3 }).map((_, index) => ({
  id: index.toString(),
}))

const ListPlaceholder = ({ includesTitle = true }) => (
  <ListSkeleton
    titleSection={
      includesTitle && (
        <LoadingBox width="204px" maxWidth="100%">
          &nbsp;
        </LoadingBox>
      )
    }
    items={placeholderItems}
    ItemComponent={() => <LoadingBox width="100%" height="104px" />}
  />
)

ListPlaceholder.propTypes = {
  includesTitle: PropTypes.bool,
}

export default ListPlaceholder
